import request, { noTokenService } from '@/utils/request'

// 值集
export function findValueBySetCode(data: any) {
  return request({
    url: 'xxx/findValueBySetCode',
    method: 'post',
    data: data,
  })
}

// 获取省市区接口
export function findAddressDictList(data: any) {
  return request({
    url: 'xxx/findAddressDictList',
    method: 'post',
    data,
  })
}

/**
 * 获取组织架构
 * @param {*} token
 */
export function findEhrOrgList(data: any) {
  return request({
    url: 'xxx/findEhrOrgList',
    method: 'post',
    data,
  })
}

// 登录
export function oauthToken(data: any) {
  return noTokenService({
    url: 'api/uaa/oauth/token',
    method: 'post',
    data,
  })
}
